import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// SVG 아이콘 컴포넌트
const Icon = ({ name, size = 16 }) => {
  const icons = {
    dashboard: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="7" height="9" rx="1"/>
        <rect x="14" y="3" width="7" height="5" rx="1"/>
        <rect x="14" y="12" width="7" height="9" rx="1"/>
        <rect x="3" y="16" width="7" height="5" rx="1"/>
      </svg>
    ),
    users: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    userPending: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="8.5" cy="7" r="4"/>
        <line x1="20" y1="8" x2="20" y2="14"/>
        <line x1="23" y1="11" x2="17" y2="11"/>
      </svg>
    ),
    report: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
        <line x1="4" y1="22" x2="4" y2="15"/>
      </svg>
    ),
    hidden: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
      </svg>
    ),
    projects: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
      </svg>
    ),
    key: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
      </svg>
    ),
    server: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
        <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
        <line x1="6" y1="6" x2="6.01" y2="6"/>
        <line x1="6" y1="18" x2="6.01" y2="18"/>
      </svg>
    ),
    monitor: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
    database: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <ellipse cx="12" cy="5" rx="9" ry="3"/>
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
      </svg>
    ),
    chevron: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    ),
    collapse: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="11 17 6 12 11 7"/>
        <polyline points="18 17 13 12 18 7"/>
      </svg>
    ),
    stock: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
        <polyline points="16 7 22 7 22 13"/>
      </svg>
    ),
    ai: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z"/>
        <circle cx="7.5" cy="14.5" r="1.5"/>
        <circle cx="16.5" cy="14.5" r="1.5"/>
      </svg>
    ),
    community: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    family: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    lab: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 3h6v2H9zM9 5l-2 12a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3L15 5"/>
        <path d="M7.5 14h9"/>
      </svg>
    ),
    terminal: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="4 17 10 11 4 5"/>
        <line x1="12" y1="19" x2="20" y2="19"/>
      </svg>
    ),
    home: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      </svg>
    ),
    lock: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
    devteam: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="16 18 22 12 16 6"/>
        <polyline points="8 6 2 12 8 18"/>
      </svg>
    ),
    work: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
      </svg>
    ),
    chart: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
    grid: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
    deploy: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    ),
    bell: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
    shield: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
    clipboard: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
      </svg>
    ),
  };
  return icons[name] || null;
};

const Sidebar = ({ collapsed, onToggle, activeSection, mobileOpen, onMobileClose, badges = {} }) => {
  const { t } = useTranslation();
  const location = useLocation();

  // 현재 경로에 따른 초기 상태 결정
  const isUsersPath = location.pathname.includes('/users');
  const isReportsPath = location.pathname.includes('/reports');
  const isProjectsPath = location.pathname.includes('/projects');
  const isServerPath = location.pathname.includes('/server');
  const isAiUsagePath = location.pathname.includes('/ai-usage');
  const isOpsPath = location.pathname.includes('/monitoring') || location.pathname.includes('/deployments') || location.pathname.includes('/alerts') || location.pathname.includes('/audit-log') || location.pathname.includes('/security');

  const [usersExpanded, setUsersExpanded] = useState(isUsersPath);
  const [reportsExpanded, setReportsExpanded] = useState(isReportsPath);
  const [projectsExpanded, setProjectsExpanded] = useState(isProjectsPath);
  const [serverExpanded, setServerExpanded] = useState(isServerPath);
  const [opsExpanded, setOpsExpanded] = useState(isOpsPath);

  // 경로 변경 시 해당 메뉴 자동 열기
  useEffect(() => {
    if (isUsersPath) setUsersExpanded(true);
    if (isReportsPath) setReportsExpanded(true);
    if (isProjectsPath) setProjectsExpanded(true);
    if (isServerPath) setServerExpanded(true);
    if (isOpsPath) setOpsExpanded(true);
  }, [location.pathname, isUsersPath, isReportsPath, isProjectsPath, isServerPath, isOpsPath]);

  // 현재 활성 경로 확인
  const isActive = (path) => location.pathname === path;

  // 모바일에서 메뉴 클릭 시 사이드바 닫기
  const handleNavClick = () => {
    if (window.innerWidth < 768 && onMobileClose) {
      onMobileClose();
    }
  };

  const navItemBase = "flex items-center gap-2.5 w-full py-2.5 px-3 border-none rounded-lg bg-transparent no-underline text-gray-500 text-sm font-normal cursor-pointer transition-all duration-150 text-left";
  const navItemHover = "hover:bg-gray-100 hover:text-gray-900";
  const navItemActive = "bg-blue-500/10 text-blue-500";

  const navSubitemBase = "flex items-center gap-2 py-2 px-2.5 rounded-md no-underline text-gray-500 text-[13px] font-normal transition-all duration-150";
  const navSubitemHover = "hover:bg-gray-100 hover:text-gray-900";
  const navSubitemActive = "bg-blue-500/10 text-blue-500";

  return (
    <aside className={`
      flex flex-col h-full bg-white border-r border-gray-200 transition-[width] duration-200 flex-shrink-0
      ${collapsed ? 'w-14' : 'w-60'}
      max-md:fixed max-md:left-0 max-md:top-[44px] max-md:bottom-0 max-md:h-[calc(100vh-44px)] max-md:z-[100] max-md:w-[280px] max-md:transform max-md:-translate-x-full max-md:shadow-none max-md:transition-transform max-md:duration-300
      ${mobileOpen ? 'max-md:translate-x-0 max-md:shadow-xl' : ''}
    `}>
      {/* Header */}
      <div className={`flex items-center justify-between p-4 border-b border-gray-200 min-h-[56px] ${collapsed ? 'justify-center px-3.5' : ''} max-md:justify-start max-md:px-5`}>
        {!collapsed && (
          <div className="flex items-center">
            <NavLink to="/" className="text-[15px] font-semibold text-gray-900 no-underline tracking-tight hover:text-blue-500">Admin</NavLink>
          </div>
        )}
        <button
          onClick={onToggle}
          className={`flex items-center justify-center w-7 h-7 p-0 bg-transparent border-none rounded-md cursor-pointer text-gray-400 transition-all duration-150 hover:bg-gray-100 hover:text-gray-900 max-md:hidden ${collapsed ? 'rotate-180' : ''}`}
          aria-label={collapsed ? '사이드바 펼치기' : '사이드바 접기'}
        >
          <Icon name="collapse" size={16} />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-3 px-2 overflow-y-auto max-md:overflow-y-auto max-md:pb-5">
        {/* 대시보드 */}
        <NavLink
          to="/"
          className={({ isActive: active }) => `${navItemBase} ${navItemHover} ${active ? navItemActive : ''} ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
          title={collapsed ? '대시보드' : undefined}
          onClick={handleNavClick}
          end
        >
          <span className={`flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors ${collapsed ? 'm-0' : ''}`}><Icon name="dashboard" /></span>
          {!collapsed && <span className="flex-1 flex items-center gap-2 whitespace-nowrap overflow-hidden text-ellipsis">대시보드</span>}
        </NavLink>

        {/* 사용자 관리 */}
        <div className={`mb-1 ${collapsed ? 'mb-0' : ''}`}>
          <button
            className={`${navItemBase} ${navItemHover} ${isUsersPath ? navItemActive : ''} mb-0.5 ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
            onClick={() => !collapsed && setUsersExpanded(!usersExpanded)}
            title={collapsed ? '사용자 관리' : undefined}
          >
            <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="users" /></span>
            {!collapsed && (
              <>
                <span className="flex-1 flex items-center gap-2 whitespace-nowrap overflow-hidden text-ellipsis">
                  {t('admin.tabs.users') || '사용자 관리'}
                  {badges.pendingUsers > 0 && (
                    <span className="bg-red-500 text-white rounded-[10px] min-w-[18px] h-[18px] inline-flex items-center justify-center text-[11px] font-medium px-1.5">{badges.pendingUsers}</span>
                  )}
                </span>
                <span className={`flex items-center justify-center text-gray-400 transition-transform duration-200 ${usersExpanded ? 'rotate-90' : ''}`}>
                  <Icon name="chevron" size={14} />
                </span>
              </>
            )}
          </button>

          {!collapsed && usersExpanded && (
            <div className="pl-5 ml-2.5 border-l border-gray-200">
              <NavLink
                to="/users"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''} max-md:min-h-[40px] max-md:py-2.5 max-md:px-3`}
                onClick={handleNavClick}
                end
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="users" size={14} /></span>
                <span>전체 회원</span>
              </NavLink>
              <NavLink
                to="/users/pending"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''} max-md:min-h-[40px] max-md:py-2.5 max-md:px-3`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="userPending" size={14} /></span>
                <span className="flex-1">승인 대기</span>
                {badges.pendingUsers > 0 && (
                  <span className="bg-red-500 text-white rounded-[10px] min-w-[18px] h-[18px] inline-flex items-center justify-center text-[11px] font-medium px-1.5">{badges.pendingUsers}</span>
                )}
              </NavLink>
            </div>
          )}
        </div>

        {/* 신고 관리 */}
        <div className={`mb-1 ${collapsed ? 'mb-0' : ''}`}>
          <button
            className={`${navItemBase} ${navItemHover} ${isReportsPath ? navItemActive : ''} mb-0.5 ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
            onClick={() => !collapsed && setReportsExpanded(!reportsExpanded)}
            title={collapsed ? '신고 관리' : undefined}
          >
            <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="report" /></span>
            {!collapsed && (
              <>
                <span className="flex-1 flex items-center gap-2 whitespace-nowrap overflow-hidden text-ellipsis">
                  {t('admin.tabs.moderation') || '신고 관리'}
                  {badges.pendingReports > 0 && (
                    <span className="bg-red-500 text-white rounded-[10px] min-w-[18px] h-[18px] inline-flex items-center justify-center text-[11px] font-medium px-1.5">{badges.pendingReports}</span>
                  )}
                </span>
                <span className={`flex items-center justify-center text-gray-400 transition-transform duration-200 ${reportsExpanded ? 'rotate-90' : ''}`}>
                  <Icon name="chevron" size={14} />
                </span>
              </>
            )}
          </button>

          {!collapsed && reportsExpanded && (
            <div className="pl-5 ml-2.5 border-l border-gray-200">
              <NavLink
                to="/reports"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''} max-md:min-h-[40px] max-md:py-2.5 max-md:px-3`}
                onClick={handleNavClick}
                end
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="report" size={14} /></span>
                <span className="flex-1">신고 관리</span>
                {badges.pendingReports > 0 && (
                  <span className="bg-red-500 text-white rounded-[10px] min-w-[18px] h-[18px] inline-flex items-center justify-center text-[11px] font-medium px-1.5">{badges.pendingReports}</span>
                )}
              </NavLink>
              <NavLink
                to="/reports/hidden"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''} max-md:min-h-[40px] max-md:py-2.5 max-md:px-3`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="hidden" size={14} /></span>
                <span className="flex-1">숨김 게시글</span>
                {badges.hiddenPosts > 0 && (
                  <span className="bg-red-500 text-white rounded-[10px] min-w-[18px] h-[18px] inline-flex items-center justify-center text-[11px] font-medium px-1.5">{badges.hiddenPosts}</span>
                )}
              </NavLink>
            </div>
          )}
        </div>

        {/* 프로젝트 관리 */}
        <div className={`mb-1 ${collapsed ? 'mb-0' : ''}`}>
          <div className={`flex items-center ${collapsed ? '' : ''}`}>
            <NavLink
              to="/projects"
              className={({ isActive: active }) => `${navItemBase} ${navItemHover} ${isProjectsPath ? navItemActive : ''} mb-0.5 ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4 flex-1`}
              title={collapsed ? '프로젝트 관리' : undefined}
              onClick={(e) => {
                handleNavClick();
              }}
              end
            >
              <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="projects" /></span>
              {!collapsed && (
                <>
                  <span className="flex-1 flex items-center gap-2 whitespace-nowrap overflow-hidden text-ellipsis">프로젝트 관리</span>
                  <span
                    className={`flex items-center justify-center text-gray-400 transition-transform duration-200 ${projectsExpanded ? 'rotate-90' : ''}`}
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setProjectsExpanded(!projectsExpanded); }}
                  >
                    <Icon name="chevron" size={14} />
                  </span>
                </>
              )}
            </NavLink>
          </div>

          {!collapsed && projectsExpanded && (
            <div className="pl-5 ml-2.5 border-l border-gray-200">
              <NavLink to="/projects/main" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="home" size={14} /></span>
                <span>Main</span>
              </NavLink>
              <NavLink to="/projects/auth" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="lock" size={14} /></span>
                <span>Auth</span>
              </NavLink>
              <NavLink to="/projects/community" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="community" size={14} /></span>
                <span>Community</span>
              </NavLink>
              <NavLink to="/projects/stock" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="stock" size={14} /></span>
                <span>Stock</span>
              </NavLink>
              <NavLink to="/projects/ai" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="ai" size={14} /></span>
                <span>AI</span>
              </NavLink>
              <NavLink to="/projects/family" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="family" size={14} /></span>
                <span>Family</span>
              </NavLink>
              <NavLink to="/projects/lab" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="lab" size={14} /></span>
                <span>Lab</span>
              </NavLink>
              <NavLink to="/projects/devteam" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="devteam" size={14} /></span>
                <span>DevTeam</span>
              </NavLink>
              <NavLink to="/projects/work" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="work" size={14} /></span>
                <span>Work</span>
              </NavLink>
              <NavLink to="/projects/openclaude" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="terminal" size={14} /></span>
                <span>Claude Terminal</span>
              </NavLink>
              <NavLink to="/projects/stockanalysis" className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`} onClick={handleNavClick}>
                <span className="flex items-center justify-center w-4 h-4"><Icon name="chart" size={14} /></span>
                <span>Stock Analysis</span>
              </NavLink>
            </div>
          )}
        </div>

        {/* 구분선 */}
        {!collapsed && <div className="h-px bg-gray-200 mx-4 my-2"></div>}

        {/* API 키 관리 */}
        <NavLink
          to="/api-keys"
          className={({ isActive: active }) => `${navItemBase} ${navItemHover} ${active ? navItemActive : ''} ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
          title={collapsed ? 'API 키 관리' : undefined}
          onClick={handleNavClick}
        >
          <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="key" /></span>
          {!collapsed && <span className="flex-1">API 키 관리</span>}
        </NavLink>

        {/* AI 사용량 */}
        <NavLink
          to="/ai-usage"
          className={({ isActive: active }) => `${navItemBase} ${navItemHover} ${(active || isAiUsagePath) ? navItemActive : ''} ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
          title={collapsed ? 'AI 사용량' : undefined}
          onClick={handleNavClick}
        >
          <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="ai" /></span>
          {!collapsed && <span className="flex-1">AI 사용량</span>}
        </NavLink>

        {/* 서버 관리 */}
        <div className={`mb-1 ${collapsed ? 'mb-0' : ''}`}>
          <button
            className={`${navItemBase} ${navItemHover} ${isServerPath ? navItemActive : ''} mb-0.5 ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
            onClick={() => !collapsed && setServerExpanded(!serverExpanded)}
            title={collapsed ? '서버 관리' : undefined}
          >
            <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="server" /></span>
            {!collapsed && (
              <>
                <span className="flex-1">서버 관리</span>
                <span className={`flex items-center justify-center text-gray-400 transition-transform duration-200 ${serverExpanded ? 'rotate-90' : ''}`}>
                  <Icon name="chevron" size={14} />
                </span>
              </>
            )}
          </button>

          {!collapsed && serverExpanded && (
            <div className="pl-5 ml-2.5 border-l border-gray-200">
              <NavLink
                to="/server/monitor"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="monitor" size={14} /></span>
                <span>시스템 모니터링</span>
              </NavLink>
              <NavLink
                to="/server/database"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="database" size={14} /></span>
                <span>데이터베이스</span>
              </NavLink>
            </div>
          )}
        </div>

        {/* 구분선 */}
        {!collapsed && <div className="h-px bg-gray-200 mx-4 my-2"></div>}

        {/* 운영 관리 */}
        <div className={`mb-1 ${collapsed ? 'mb-0' : ''}`}>
          <button
            className={`${navItemBase} ${navItemHover} ${isOpsPath ? navItemActive : ''} mb-0.5 ${collapsed ? 'justify-center px-2.5' : ''} max-md:min-h-[44px] max-md:py-3 max-md:px-4`}
            onClick={() => !collapsed && setOpsExpanded(!opsExpanded)}
            title={collapsed ? '운영 관리' : undefined}
          >
            <span className="flex items-center justify-center w-5 h-5 flex-shrink-0 text-gray-400 transition-colors"><Icon name="shield" /></span>
            {!collapsed && (
              <>
                <span className="flex-1">운영 관리</span>
                <span className={`flex items-center justify-center text-gray-400 transition-transform duration-200 ${opsExpanded ? 'rotate-90' : ''}`}>
                  <Icon name="chevron" size={14} />
                </span>
              </>
            )}
          </button>

          {!collapsed && opsExpanded && (
            <div className="pl-5 ml-2.5 border-l border-gray-200">
              <NavLink
                to="/monitoring"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="monitor" size={14} /></span>
                <span>모니터링</span>
              </NavLink>
              <NavLink
                to="/deployments"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="deploy" size={14} /></span>
                <span>배포 관리</span>
              </NavLink>
              <NavLink
                to="/alerts"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="bell" size={14} /></span>
                <span>알림</span>
              </NavLink>
              <NavLink
                to="/audit-log"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="clipboard" size={14} /></span>
                <span>감사 로그</span>
              </NavLink>
              <NavLink
                to="/security"
                className={({ isActive: active }) => `${navSubitemBase} ${navSubitemHover} ${active ? navSubitemActive : ''}`}
                onClick={handleNavClick}
              >
                <span className="flex items-center justify-center w-4 h-4"><Icon name="shield" size={14} /></span>
                <span>보안 대시보드</span>
              </NavLink>
            </div>
          )}
        </div>
      </nav>

      {/* Spacer */}
      <div className="flex-1 max-md:hidden"></div>

      {/* Footer */}
      {!collapsed && (
        <div className="py-3 px-4 border-t border-gray-200 flex-shrink-0">
          <span className="text-xs text-blue-500 bg-blue-500/10 px-2.5 py-1 rounded-xl font-medium">관리자</span>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
